import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		token: '',
		userInfo: {
			userId: '',
			userName: '',
			userAccount: '',
			avatar: '',
			prevLoginTime: '',
			prevLoginIPAddress: '',
			expiry: ''
		}
	},
	mutations: {
		mutUserCode: function(state, payload){
			state.token													= payload.token
		},
		mutUserInfo: function(state, payload){
			state.token													= payload.token
			state.userInfo.userId								= payload.userInfo.userId
			state.userInfo.userName							= payload.userInfo.userName
			state.userInfo.userAccount					= payload.userInfo.userAccount
			state.userInfo.avatar								= payload.userInfo.avatar
			state.userInfo.prevLoginTime				= payload.userInfo.prevLoginTime
			state.userInfo.prevLoginIPAddress		= payload.userInfo.prevLoginIPAddress
			state.userInfo.expiry								= payload.userInfo.expiry
		}
	},
	actions: { 
		actUserCode: function(context, payload){
			return new Promise((resolve, reject) => {
				context.commit('mutUserCode', payload)
				resolve(payload)
			})
		},
		actUserInfo: function(context, payload){
			return new Promise((resolve, reject) => {
				context.commit('mutUserInfo', payload)
				resolve(payload)
			})
		},
	},
	getters: {
		
	},
	modules: {
		
	}
})

export default store